/*
 * @Author: tager
 * @Date: 2022-06-06 16:45:35
 * @LastEditors: tager
 * @LastEditTime: 2022-06-13 16:09:05
 * @Description: file content
 */
import './App.scss'
import { Routers } from './router'
import { hot } from 'react-hot-loader/root'
function App() {
  return (
    <div className="App">
      <Routers />
    </div>
  )
}
export default process.env.NODE_ENV === 'development' ? hot(App) : App
